import axios from "axios";

import client from "@/utils/axios";
import { formatTransactionsForTable } from "@/utils/formatters";
import { getUniqueListBy, prepareTransactionsFilters } from "@/utils/helpers";

let cancel;

export default {
  namespaced: true,

  state: {
    transactions: [],
  },

  actions: {
    async fetch({ commit }, filters = {}) {
      const params = prepareTransactionsFilters(filters.parameters, filters.tab);

      if (cancel) {
        cancel.cancel();
      }

      cancel = axios.CancelToken.source();

      if (filters.clear) {
        commit("setTransactions", []);
      }

      try {
        const { data } = await client.get(`/api/v2/my/transactions`, {
          params,
          cancelToken: cancel.token,
        });

        commit("setTransactions", data);
      } catch (e) {
        console.log("Failed to fetch transactions", e);
      }
    },

    async update({ state, commit }, newTransactions) {
      const transactionsByInternalId = newTransactions.reduce((memo, transaction) => {
        memo[transaction.internalId] = transaction;
        return memo;
      }, {});

      const transactions = state.transactions.map((transaction) => {
        return transactionsByInternalId[transaction.internalId] || transaction;
      });

      commit("setTransactions", transactions);
    },

    async add({ state, commit }, newTransactions) {
      let all = getUniqueListBy(
        [...newTransactions, ...state.transactions],
        "id"
      );

      if (all.length > 2000) {
        all = all.slice(0, all.length - newTransactions.length);
      }

      commit("setTransactions", all);
    },
  },

  getters: {
    transactions(state) {
      return formatTransactionsForTable(state.transactions);
    },
    latest10Transactions(_, getters) {
      const { transactions } = getters;
      return transactions.slice(0, 10);
    },
    internalIdToTransactionMap(state) {
      return state.transactions.reduce((memo, transaction) => {
        const { internalId } = transaction;
        memo[internalId] = transaction;
        return memo;
      }, {});
    }
  },

  mutations: {
    setTransactions(state, data) {
      state.transactions = data;
    },
  },
};
